import { PayrollStatus } from "@wingspanhq/wingspan-api-sdk";

import { PayrollRunStatus } from "../types";

/**
 * Collapse the 7-value v3 `PayrollStatus` onto the 5 statuses the UI renders.
 * `Finalized` and `Processing` both read as "processing" (funds in flight);
 * `Cancelled` and `Failed` both read as "failed".
 */
export const selectorPayrollRunStatus = (
  status?: PayrollStatus
): PayrollRunStatus => {
  switch (status) {
    case PayrollStatus.DRAFT:
      return "opened";
    case PayrollStatus.PENDING_APPROVALS:
      return "pending";
    case PayrollStatus.FINALIZED:
    case PayrollStatus.PROCESSING:
      return "processing";
    case PayrollStatus.PAID:
      return "completed";
    case PayrollStatus.CANCELLED:
    case PayrollStatus.FAILED:
      return "failed";
    default:
      return "pending";
  }
};
